import React, { useState, useEffect } from "react";
import classes from "./styles.module.scss";
import Logo from "../../assets/images/image 967.png";
import { Link, useNavigate } from "react-router-dom";
import DropdownMenuButton from "../../components/dropdownMenuButton";
import {
  getStudentsResourceMenuOption,
  getNotificationMenuOptions,
  getLoginMenuOptions,
} from "./routesConfig";
import Button from "../../components/buttonPrimary";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "../../context/language";

const NavbarComponent = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const studentsResourceMenuOption = getStudentsResourceMenuOption(t);
  const notificationMenuOptions = getNotificationMenuOptions(t);
  const LoginMenuOptions = getLoginMenuOptions(t);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1024 && isMobileMenuOpen) {
        setIsMobileMenuOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isMobileMenuOpen]);

  return (
    <div className={classes.navbar_container}>
      <div className={classes.navbar_left_logo}>
        {/* logo */}
        <Link to={"/"}>
          <div className={classes.brand_logo_text}>
            <img src={Logo} alt="brand_image" />
            <p className={classes.text}>
              <span>Gyandeep</span>
              <span>{t("hero.rightToEducation")}</span>
            </p>
          </div>
        </Link>
      </div>

      {/* Hamburger Menu Icon for Mobile */}
      <div className={classes.mobile_menu_icon} onClick={toggleMobileMenu}>
        <MenuIcon sx={{ fontSize: "28px" }} />
      </div>

      {/* menu items */}
      <div className={classes.navbar_menu_right}>
        {/* tutorial Button */}
        <Button
          button_text={t("navbar.tutorial")}
          variant="button_secondary"
          second_className={classes.blinkingButton}
          onClick={() => navigate("/tutorial")}
        />

        {/* student resource */}
        <DropdownMenuButton
          defualtLabel={t("navbar.studentResources")}
          options={studentsResourceMenuOption}
          trigger="click"
        />
        {/* notification */}
        <DropdownMenuButton
          defualtLabel={t("navbar.notifications")}
          trigger="click"
          options={notificationMenuOptions}
        />
        {/* contact */}
        <Button
          button_text={t("navbar.contactUs")}
          variant="button_secondary"
          onClick={() => navigate("/contact")}
        />

        <Button
          button_text={t("navbar.faq")}
          variant="button_secondary"
          onClick={() => navigate("/faq")}
        />
        {/* login */}
        <DropdownMenuButton
          defualtLabel={t("navbar.login")}
          trigger="click"
          options={LoginMenuOptions}
          variant={"secondary"}
        />
        {/* Student Registration btn */}
        {parseInt(process.env.REACT_APP_RESISTRATION) !== 0 && (
          <Button
            button_text={t("navbar.studentRegistration")}
            variant="button_ternary"
            onClick={() => navigate("/registration-aadhaar-details")}
          />
        )}
      </div>

      {/* Mobile Sidebar Overlay */}
      {isMobileMenuOpen && (
        <div
          className={classes.mobile_overlay}
          onClick={toggleMobileMenu}
        ></div>
      )}

      {/* Mobile Drawer */}
      <div
        className={`${classes.mobile_sidebar} ${
          isMobileMenuOpen ? classes.open : ""
        }`}
      >
        <div className={classes.sidebar_header}>
          <div className={classes.brand_logo_text}>
            <img src={Logo} alt="brand_image" />
            <p className={classes.text}>
              <span>Gyandeep</span>
              <span>{t("hero.rightToEducation")}</span>
            </p>
          </div>
          <div className={classes.close_icon} onClick={toggleMobileMenu}>
            <CloseIcon />
          </div>
        </div>

        <div className={classes.sidebar_content}>
          <DropdownMenuButton
            defualtLabel={t("navbar.studentResources")}
            options={studentsResourceMenuOption}
            trigger="click"
            className={classes.mobile_dropdown}
            menuClassName={classes.mobile_dropdown_menu}
          />
          <DropdownMenuButton
            defualtLabel={t("navbar.notifications")}
            trigger="click"
            options={notificationMenuOptions}
            className={classes.mobile_dropdown}
            menuClassName={classes.mobile_dropdown_menu}
          />
          <div className={classes.mobile_tutorial}>
            {/* tutorial */}
            <Button
              button_text={t("navbar.tutorial")}
              variant="button_secondary"
              onClick={() => {
                navigate("/tutorial");
                toggleMobileMenu();
              }}
            />
          </div>
          <div className={classes.mobile_contact_us}>
            {/* contact */}
            <Button
              button_text={t("navbar.contactUs")}
              variant="button_secondary"
              onClick={() => {
                navigate("/contact");
                toggleMobileMenu();
              }}
            />
          </div>
          <div className={classes.mobile_faq}>
            {/* faq */}
            <Button
              button_text={t("navbar.faq")}
              variant="button_secondary"
              onClick={() => {
                navigate("/faq");
                toggleMobileMenu();
              }}
            />
          </div>

          <div className={classes.mobile_login_section}>
            <DropdownMenuButton
              defualtLabel={t("navbar.login")}
              trigger="click"
              options={LoginMenuOptions}
              className={classes.mobile_dropdown_login}
              menuClassName={classes.mobile_dropdown_menu}
            />
          </div>

          {parseInt(process.env.REACT_APP_RESISTRATION) !== 0 && (
            <div className={classes.mobile_register_btn}>
              <Button
                button_text={t("navbar.studentRegistration")}
                variant="button_ternary"
                onClick={() => navigate("/registration-aadhaar-details")}
              />
            </div>
          )}

          {/* <div className={classes.more_accessible}>
            <AccessibleIcon fontSize="small" /> <span>More</span>
          </div> */}
        </div>

        <div className={classes.sidebar_footer}>
          <p>
            18003454417 / 14417 | (10AM to 5PM, <br />
            Monday to Saturday)
          </p>
          <Link
            to="mailto:rtebiharhelp@gmail.com"
            className={classes.text_white}
          >
            rtebiharhelp@gmail.com
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NavbarComponent;
